import { FC, PropsWithChildren, useEffect } from 'react';

import { skipToMainStyle } from './SkipToMain.css';
import { useI18nTranslation } from '../../providers/i18n';
import { ButtonLink } from '../ButtonLink/ButtonLink';

const Main: FC<PropsWithChildren<{ className?: string }>> = ({ children, className }) => {
  return (
    <main id="main" className={className}>
      {children}
    </main>
  );
};

const SkipLink: FC = () => {
  const buttonText = useI18nTranslation('skipToMain');
  useEffect(() => {
    if (process.env.NODE_ENV === 'development') {
      const mainCounter = document.querySelectorAll('[id="main"]').length;
      if (mainCounter !== 1) {
        // eslint-disable-next-line no-console
        console.error(
          `Error: The <SkipToMain.SkipLink> button requires one item to be identified as "main", but this amount was found: ${mainCounter}. Use <SkipToMain.Main> to wrap the main content that can be skipped to, and make sure it is only rendered once per page. Check the docs of \`SkipToMain\` for more info.`,
        );
      }
    }
  }, []);

  return (
    <div className={skipToMainStyle}>
      <ButtonLink action="secondary" href="#main">
        {buttonText}
      </ButtonLink>
    </div>
  );
};

export const SkipToMain = { SkipLink, Main };

SkipLink.displayName = 'SkipToMain.SkipLink';
